import React from "react";
import "../css/chat.css";

export default function ChatHeader({ profile, onAvatarClick, onCall }) {
  if (!profile) return null;

  return (
    <div className="chat-header">
      <div className="chat-header-left" onClick={onAvatarClick}>
        <img
          src={profile.avatar || "/default-avatar.png"}
          alt="avatar"
          className="chat-avatar"
        />
        <span className="chat-name">{profile.name}</span>
      </div>

      <div className="chat-header-actions">
        <button
          onClick={() => onCall("audio")}
          className="call-btn"
          title="Start Voice Call"
          aria-label="Start Voice Call"
        >
          📞
        </button>
       
      </div>
    </div>
  );
}